@if (content.activities) {
  <div class="skymiles-landing-page-snapshot">
    <div class="skymiles-landing-page-snapshot__title">
      <h1 [innerHTML]="content.title"></h1>
    </div>

    <aura-toggle-area
      [entryItem]="content.toggle"
      [textEllipsis]="false"
      [separator]="false"
      [stylesArray]="expanderStyle"
      auraCustomStyles
    >
      <aura-divider
        [type]="'dark'"
        [stylesArray]="dividerStyle"
        auraCustomStyles
      ></aura-divider>
      @for (activity of content.activities; track $index) {
        <div
          class="skymiles-landing-page-snapshot__entry-item"
          [stylesArray]="entryItemStyle"
          auraCustomStyles
        >
          <aura-entry-item
            [entryItem]="activity"
            [textEllipsis]="false"
          ></aura-entry-item>
          @if (!$last) {
            <aura-divider
              [type]="'light'"
              [stylesArray]="dividerStyle"
              auraCustomStyles
            ></aura-divider>
          }
        </div>
      }
      <aura-divider
        [type]="'dark'"
        [stylesArray]="dividerStyle"
        auraCustomStyles
      ></aura-divider>

      <div class="skymiles-landing-page-snapshot__action">
        <idp-link
          [axLabel]="content.action.label"
          [label]="content.action.label"
          [labelSize]="'double-extra-large'"
          [actionUrl]="content.action.url"
          [id]="content.action.id || '#'"
          (click)="onLinkClick(content.action.label, content.action.url)"
        ></idp-link>
      </div>
    </aura-toggle-area>
  </div>
}
